import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { stringify } from 'qs';

import { IN_HOUSE_ANALYTICS_SUB_STRING } from '../constants';
import { ANALYTICS_SHOW_ACCOUNT } from '@/modules/@common/acl/constants';

import * as selectors from '../redux/selectors';
import { hasPermission } from '@/modules/@common/user/helpers';

export const canSelectAccount = (userPermissions) => hasPermission(ANALYTICS_SHOW_ACCOUNT, userPermissions);

export const useGeneralMenu = () => {
  const account = useSelector(selectors.accountSelector);
  const menu = useSelector(selectors.menuSelector);
  const storedInHouseMenuSettings = useSelector(selectors.storedInHouseMenuSettingsSelector);

  return useMemo(() => {
    const menuByType = (menu ?? []).reduce(
      (acc, value) => ({
        ...acc,
        [value.type]: [].concat(acc[value.type] ?? [], value),
      }),
      {},
    );

    const createLookerMenuItem = (item) => {
      const queryParams = { selectedAnalytic: item.name };

      if (account) {
        queryParams.publisherName = account.label;
        queryParams.salesforceId = account.salesforceId;
      }

      return {
        title: item.name,
        href: `/analytics?${stringify(queryParams)}`,
      };
    };

    const createInHouseMenuItem = (item) => {
      const [, type] = item.lookerReportId.split('::');
      return storedInHouseMenuSettings?.[type] ?? null;
    };

    const createMenuByType = (menuListByType) => {
      if (!menuListByType) {
        return [];
      }

      const menuResult = menuListByType.map((menuItem) => {
        const isInHouseMenuItem = menuItem.lookerReportId.includes(IN_HOUSE_ANALYTICS_SUB_STRING);
        return isInHouseMenuItem ? createInHouseMenuItem(menuItem) : createLookerMenuItem(menuItem);
      });

      return menuResult.filter(Boolean);
    };

    return {
      generalMenu: createMenuByType(menuByType.general),
      customMenu: createMenuByType(menuByType.custom),
    };
  }, [account, menu, storedInHouseMenuSettings]);
};

export default canSelectAccount;
